<div class="crossIcon" (click) = "cancel()">
  <ion-icon name="close-outline"></ion-icon>
</div>

<div class="box">
  <p id ="txt">CLEAR</p>
  <ion-row>
    <div class="card">
      <img src="\assets\icon\filter-modal1.svg">
      <p>Inventory Management</p>
    </div>
    <div class="card">
      <img src="\assets\icon\filter-modal2.svg">
      <p>Order Management</p>
    </div>
    <div class="card">
      <img src="\assets\icon\filter-modal3.svg">
      <p>Procurement Management</p>
    </div>
    <div class="card">
      <img src="\assets\icon\truck.svg">
      <p>Delivery Management</p>
    </div>
  </ion-row>
  <ion-row>
    <div class="card">
      <img src="\assets\icon\filter-modal4.svg">
      <p>Finance Management</p>
    </div>
    <div class="card">
      <img src="\assets\icon\filter-modal5.svg">
      <p>PoS Executive</p>
    </div>
    <div class="card">
      <img src="\assets\icon\filter-modal6.svg">
      <p>Store Manager</p>
    </div>
    <div class="card" id="trans">
      <img src="\assets\icon\filter-modal6.svg">
      <p>Store Manager</p>
    </div>
  </ion-row>
</div>
